import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFlag,
  setIsPopup,
  setResponseDescription,
  setResponseInfo,
  setResponseTitle,
} from "../features/responseSlice";
import { useExchangeApi } from "../api/ExchangeAPI";
import {
  setActionPayload,
  setActionType,
} from "../features/authorizationSlice";
import { ACTION_TYPES } from "../app/actionTypes";
import { Modal } from "react-bootstrap";
import "../../src/utils/Style/component/modals.scss";
import {
  capitalizeFirstLetters,
  formatCurrency,
} from "../features/ValueFormater";
import QRCodeDisplay from "./QrCodeDisplay";
import QrDownload from "./QrDownload";
import { validationFlags } from "../utils/Constants";
import { roleAuth } from "../utils/functionAuthorization";
import { useNavigate } from "react-router-dom";
import { restBillsData } from "../features/billsPageSlice";
import PaymentConfirmationPrePaid from "./PaymentComfirmationPrePaid";
import CashAdvancePopup from "./Payrolls/CashAdvancePopup";
import {
  setIsOpenCashAdvancePopup,
  setIsOpenSuccessModal,
} from "../features/AdvancePayrollConfirmPopupSlice";
import useCashOutApi from "../api/CashOutAPI";
import MapView from "./../components/BobMap/MapView";
import { format } from "date-fns";
const flagIconMap = {
  0: "/Images/check.png",
  1: "/Images/check.png",
  435: "/Images/warning.png",
  436: "/Images/warning.png",
  437: "/Images/warning.png",
};

function ValidationPopup({ onOpenQrAfterGenerate }) {
  const [icon, setIcon] = useState("/Images/caution.png");
  const [copyText, setCopyText] = useState("Copy Code");
  const [qr, setQr] = useState(null);
  const [showMap, setShowMap] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const { flag, responseTitle, responseDescription, isPopup, info } =
    useSelector((state) => state.transferResponse);
  const { isOpenSuccessModal } = useSelector(
    (state) => state.advancePayrollConfirm,
  );
  const currentPage = useSelector((state) => state.billsPage.currentPage);
  const { getExchangeRate, exchangeRate } = useExchangeApi();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { SendSmsCode } = useCashOutApi();
  const clicked = useSelector((state) => state.billsPage.esim.click);

  const priceEsim = useSelector((state) => state.billsPage.esim.Price);
  const nameEsim = useSelector((state) => state.billsPage.esim.name);
  const suyool = useSelector((state) => state.legalEnrollment.suyoolredirect);

  useEffect(() => {
    if (isPopup && isOpenSuccessModal) {
      onOpen();
    } else {
      onClose();
    }
  }, [isPopup, onOpen, onClose, isOpenSuccessModal]);

  useEffect(() => {
    if (flag === 11) {
      getExchangeRate();
    } else if (flag === 22) {
      dispatch(setIsOpenCashAdvancePopup(true));

      onClose();
      return;
    }
    dispatch(setIsOpenSuccessModal(true));
  }, [flag]);

  const onClosePopup = () => {
    setShowMap(false);
    dispatch(setIsPopup(false));
    dispatch(setResponseTitle(null));
    dispatch(setResponseDescription(null));
    setTimeout(() => {
      dispatch(setFlag(null));
    }, 3000);
    if (currentPage !== "pin-confirm") {
      dispatch(restBillsData());
    }
    if (flag !== validationFlags.payrollError) dispatch(setResponseInfo(null));
    onClose();
  };

  function InitiateExchange() {
    dispatch(setActionType(ACTION_TYPES.INITIATE_EXCHANGE));
    dispatch(
      setActionPayload({
        ExchangeFromAmount: info?.amount,
        ExchangeFromCurrencyID: info?.currencyFrom,
        ExchangeToCurrencyID: info?.currencyTo,
        ExchangeBuy: exchangeRate?.Buy,
        ExchangeSell: exchangeRate?.Sell,
      }),
    );
    onClosePopup();
    onOpenQrAfterGenerate();
  }

  useEffect(() => {
    if (flag !== null) {
      const iconPath = flagIconMap[Number(flag)] || "/Images/caution.png";
      setIcon(iconPath);
    }
  }, [flag]);

  function copyCodeToClipboard() {
    // Create a new textarea element to temporarily hold the code
    const textarea = document.createElement("textarea");
    textarea.data = info.Code;

    // Append the textarea to the DOM
    document.body.appendChild(textarea);
    textarea.select();

    try {
      navigator.clipboard.writeText(info.Code);
      setCopyText("Code Copied");
    } catch (err) {
      setCopyText("Copy Code");
    }

    document.body.removeChild(textarea);
  }

  const gotosuyool = () => {
    window.location.href = "https://www.suyool.com";
  };

  return (
    <>
      {flag === 22 ? (
        <CashAdvancePopup />
      ) : (
        <Modal centered show={isOpen} onHide={onClosePopup}>
          <Modal.Body>
            {showMap ? (
              <div
                className="map-container-wrapper"
                style={{
                  height: "650px",
                  maxHeight: "90%",
                  position: "relative",
                }}
              >
                <MapView onBack={() => setShowMap(false)} />
              </div>
            ) : (
              <>
                <button
                  className="skip-btn"
                  onClick={() => {
                    onClosePopup();
                  }}
                >
                  &times;
                </button>
                {flag === 101 ? (
                  <PaymentConfirmationPrePaid />
                ) : (
                  <>
                    <div className="header">
                      <div className="modal-header-image">
                        <img
                          src={
                            Number(info?.GlobalCode) === 6
                              ? "/Images/cashDelivery/cashpickup.png"
                              : Number(info?.GlobalCode) === 5
                                ? "/Images/cashDelivery/bobSucces.png"
                                : icon
                          }
                          alt="Status Icon"
                        />
                      </div>
                      {info?.GlobalCode !== 7 && (
                        <div
                          className={
                            info?.GlobalCode === 6 ? "cashin-text" : ""
                          }
                        >
                          {responseTitle}
                        </div>
                      )}
                    </div>
                    {info?.GlobalCode !== 6 && (
                      <>
                        <div className="response-message">
                          <div
                            className={
                              info?.GlobalCode === 6 ? "cashin-text" : ""
                            }
                            dangerouslySetInnerHTML={{
                              __html: clicked
                                ? `You have successfuly topped up the $ ${priceEsim}  ${nameEsim} esim`
                                : responseDescription,
                            }}
                          ></div>
                        </div>
                      </>
                    )}
                    {info?.GlobalCode === 5 && (
                      <div className="cashout-popup-bob">
                        <div className="info-row">
                          <div className="title">Amount</div>
                          <div className="data">
                            {formatCurrency(info?.Amount)}
                          </div>
                        </div>

                        <div className="info-row">
                          <div className="title">Depositor Name</div>
                          <div className="data">
                            {capitalizeFirstLetters(info?.ReceiverName)}
                          </div>
                        </div>

                        <div className="code-section">
                          <div className="code-instruction">
                            Use this code at any BOB outlet to cash out:
                          </div>
                          <div className="code-box">{info?.Code}</div>
                        </div>

                        <div className="action-buttons">
                          {info?.SendSms && (
                            <button
                              className="btn-sms-primary"
                              onClick={async () => {
                                await SendSmsCode(info?.phone, info?.Code);
                                onClosePopup();
                              }}
                            >
                              Send Code Via SMS
                            </button>
                          )}

                          <button
                            className="btn-copy-outline"
                            onClick={copyCodeToClipboard}
                          >
                            {copyText}
                          </button>
                        </div>

                        {/* New Warning/Branch Box */}
                        <div className="branch-warning">
                          <div className="icon">!</div>
                          <p>
                            Cash in amount only available at these <br />
                            <button
                              type="button"
                              className="btn-link p-0 border-0 bg-transparent text-primary text-decoration-underline orange-color"
                              onClick={() => setShowMap(true)}
                              style={{ cursor: "pointer", fontSize: "inherit" }}
                            >
                              BOB Branches
                            </button>
                          </p>
                        </div>
                        <div className="expiry-text">
                          This code is only available for 24h
                        </div>
                      </div>
                    )}

                    {info?.GlobalCode === 6 && (
                      <div className="cashout-popup">
                        {info?.CashoutType === 2 && (
                          <div className="response-message mt-3">
                            <div className="cashin-text">
                              Kindly show the below QR to the Suyool courier to
                              confirm the funds pick up.
                            </div>
                          </div>
                        )}

                        {((info?.Method === "cashout" &&
                          roleAuth(
                            "cashout",
                            "DOWNLOAD_CONFIRMATION_QR_CASH_OUT",
                          )) ||
                          (info?.Method === "cashin" &&
                            roleAuth(
                              "cashin",
                              "DOWNLOAD_CONFIRMATION_QR_CASH_IN",
                            ))) && (
                          <>
                            <div className="info-row">
                              <div className="title">
                                Amount Pick Up & Deposit
                              </div>
                              <div className="data">
                                {formatCurrency(info?.Amount)}
                              </div>
                              <div className="title">Address</div>
                              <div className="data">{info?.Address}</div>
                            </div>

                            {/* {info.QRCode && <QRCodeDisplay link={info.QRCode} />} */}

                            {/* <div className="qr-text">
                          The QR is saved on your dashboard
                        </div> */}

                            <button
                              id="closeModalBtn"
                              onClick={() => {
                                setQr(info?.QRCode);
                              }}
                            >
                              Download QR
                            </button>
                          </>
                        )}

                        <QrDownload qrCodeData={qr} setQrData={setQr} />
                      </div>
                    )}

                    {info?.GlobalCode === 7 && (
                      <div className="cash-collection-popup">
                        <h3>
                          {" "}
                          {info?.deliveryService === 1
                            ? "Cash delivery request sent"
                            : "Cash collection request sent"}
                        </h3>
                        <div className="delivery-service-section">
                          <img
                            src={"/Images/cashDelivery/delivery-service.png"}
                            alt="Delivery Service Icon"
                            className="delivery-service-icon"
                          />
                          <div className="delivery-info">
                            <h3>{info?.Title}</h3>
                            <p>
                              {info?.PaymentTo === 1
                                ? "Business"
                                : "Individual"}{" "}
                            </p>
                          </div>
                        </div>
                        <div className="info-section">
                          <div className="info-row">
                            <span>
                              {" "}
                              {info?.deliveryService === 1
                                ? "Total Amount the Recipient Will Receive"
                                : "Total Amount to Collect"}
                            </span>
                            <strong>{formatCurrency(info?.Amount)}</strong>
                          </div>

                          <div className="info-row">
                            <span>Additional Fees</span>
                            <strong>{info?.Fees}</strong>
                          </div>

                          <div className="info-row">
                            <span>Payment Reference</span>
                            <strong>{info?.PaymentReference}</strong>
                          </div>

                          {info?.FileName && info?.FileUrl && (
                            <div className="info-row">
                              <span>File</span>
                              <a
                                href={info.FileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#000000", fontWeight: 600 }}
                              >
                                {info.FileName}
                              </a>
                            </div>
                          )}

                          <div className="info-row">
                            <span>Person in Charge*</span>
                            <strong>{info?.PersonInCharge}</strong>
                          </div>

                          {info?.MobileNo && (
                            <div className="info-row">
                              <span>Phone Number</span>
                              <strong>{info?.MobileNo}</strong>
                            </div>
                          )}

                          {info?.Email && (
                            <div className="info-row">
                              <span>Email</span>
                              <strong>{info?.Email}</strong>
                            </div>
                          )}

                          <div className="info-row">
                            <span>Date & Time</span>
                            <strong>
                              {info?.DateTime &&
                                `${format(new Date(info.DateTime), "dd MMM yyyy").toUpperCase()} - ${format(new Date(info.DateTime), "h:mm a").toLowerCase()}`}
                            </strong>
                          </div>

                          <div className="info-row">
                            <span>Delivery Location</span>
                            <strong>{info?.Address}</strong>
                          </div>
                        </div>

                        {/* QR */}
                        {info?.QRCode && (
                          <div className="qr-section">
                            <QRCodeDisplay link={info?.QRCode} />
                          </div>
                        )}

                        <div className="action-buttons">
                          <button onClick={() => setQr(info?.QRCode)}>
                            <img
                              src={"/Images/cashDelivery/downloading.svg"}
                              className="btn-icon-butler"
                            />
                            Download QR
                          </button>

                          <button
                            onClick={() =>
                              navigator?.share?.({ url: info?.QRCode })
                            }
                          >
                            <img
                              src={"/Images/cashDelivery/copy-Filled.svg"}
                              className="btn-icon-butler"
                            />
                            Share QR
                          </button>
                        </div>

                        <QrDownload qrCodeData={qr} setQrData={setQr} />
                      </div>
                    )}
                    {![5, 6, 7].includes(info?.GlobalCode) && (
                      <div className="buttons">
                        {flag === 11 ? (
                          <div className="closeTransferModalBtn">
                            <button
                              id="closeTransferModalBtn"
                              onClick={() => {
                                onClosePopup();
                              }}
                            >
                              Not Now
                            </button>
                            <button
                              id="closeModalBtn"
                              onClick={() => {
                                InitiateExchange();
                              }}
                            >
                              Proceed
                            </button>
                          </div>
                        ) : (
                          <>
                            {flag === 84 || flag === 90 ? (
                              <div className="mt-4">
                                {flag === 84 && (
                                  <div className="centred">
                                    <button
                                      id="closeModalBtn"
                                      onClick={() => {
                                        onClosePopup();
                                        navigate("/exchange");
                                      }}
                                    >
                                      Exchange
                                    </button>
                                  </div>
                                )}
                                {flag === 90 && (
                                  <div className="centred">
                                    <button
                                      id="closeModalBtn"
                                      onClick={() => {
                                        onClosePopup();
                                        navigate("/cashin");
                                      }}
                                    >
                                      Add Money
                                    </button>
                                  </div>
                                )}

                                <div className="centered">
                                  <button
                                    id="closeModalBtn2"
                                    onClick={() => {
                                      onClosePopup();
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <>
                                {info?.InstallEsim ? (
                                  <div className="centered">
                                    {clicked ? (
                                      <button
                                        id="closeModalBtn-ok"
                                        onClick={() => {
                                          navigate("/bills");
                                          onClosePopup();
                                        }}
                                      >
                                        OK!
                                      </button>
                                    ) : (
                                      <button
                                        id="closeModalBtn"
                                        onClick={() => {
                                          navigate(
                                            "/bills/esim?comp=install-esim",
                                          );
                                          onClosePopup();
                                        }}
                                      >
                                        Install eSIM
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <div className="centered">
                                    <button
                                      id="closeModalBtn"
                                      onClick={() => {
                                        suyool ? gotosuyool() : onClosePopup();
                                      }}
                                    >
                                      OK
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}

export default ValidationPopup;
